import { Rokojori } from "../../../_rokojori.com/js/Rokojori";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { ElementType } from "../../dom-tools/ElementType";
import { OnClick } from "../../dom-tools/EventListeners";
import { InputData } from "../input/InputData";
import { PHPResponse } from "../PHPResponse";
import { COOKIE_INFO_MARK_AS_READ, COOKIE_INFO_WAS_READ, PHPAdresses } from "../PHPAdress";
import { PHPContext } from "../PHPContext";
import { PHPRequest } from "../PHPRequest";


export class CookieInfo
{
  static status:boolean = undefined;

  static async applyOnDocument( context:PHPContext, showCallback:()=>HTMLElement, hideCallback:()=>void )
  { 
    if ( this.status === undefined )
    {
      let wasReadRequst = new PHPRequest<COOKIE_INFO_WAS_READ,InputData,PHPResponse>( PHPAdresses.COOKIE_INFO_WAS_READ );
      let result = await wasReadRequst.request( context, new InputData() );
      
      if ( result.error )
      {
        CookieInfo.status = true;
      }
      else
      {
        CookieInfo.status = false;
      }

    }
    
    if ( this.status === true )
    {
      this.showCookieInfo( context, showCallback, hideCallback )
    }
  }

  static showCookieInfo( context:PHPContext, showCallback:()=>HTMLElement, hideCallback:()=>void )
  {
    let button = showCallback();

    OnClick.add( button, 
      ()=>
      {        
        CookieInfo.status = false;

        hideCallback(); 

        let markRequst = new PHPRequest<COOKIE_INFO_MARK_AS_READ,InputData,PHPResponse>( PHPAdresses.COOKIE_INFO_MARK_AS_READ );
        markRequst.request( context, new InputData() );
      }
      
    );
  }




}